import { Grid, Typography } from "@mui/material";
import team from "./components/resources/team";
import { useParams } from 'react-router-dom';

function TeamView() {
  const { name } = useParams();

  return (
    <div>
      {team.map((info, index) => {
        return (
          <div key={index}>
            {info.Name === name ? (
              <Grid
                container
                style={{ justifyContent: "center", marginTop: 100 }}
              >
                <img
                  alt={''}
                  style={{ height: 350, borderRadius: 30 }}
                  src={info.image}
                />

                <Grid item xs={12} style={{ textAlign: "center" }}>
                  {" "}
                  <Typography style={{ fontFamily: "Raleway", fontSize: 32 }}>
                    {info.Name}
                  </Typography>
                </Grid>

                <Grid item md={9} xs={11}>
                  <Typography style={{ fontFamily: "Raleway" }}>
                    {" "}
                    {info.About}
                  </Typography>
                </Grid>
              </Grid>
            ) : (
              ""
            )}
          </div>
        );
      })}
    </div>
  );
}

export default TeamView;
